import {allocationTypeDecimals} from '../utils/number';
/**
 * Singleton class that control purchase requests.
 */
export class AccountDetailsController {
    /**
     * Take the values of the allocateFor fields and check if the values are valid. Values are valid if their sum equals
     * the general total (e.g. if we are in percentage mode, the sum of the values should be 100)
     * @param {[]} values
     * @param {number} total
     * @return {boolean}
     */
    static checkAllocateForValues(values, total) {
        const allocationSum = values.reduce((sum, allocation) => sum + allocation.value, 0);
        const diff = allocationSum - total;
        const epsilon = 1e-6;
        const isTotalIncorrect = Math.abs(diff) > epsilon;
        const isThereNegativeValue = values.some((allocateFor) => allocateFor.value < 0);

        return isTotalIncorrect || isThereNegativeValue;
    }

    /**
     * Balance equally the remaining total between the unfixed accounts.
     * @param {[]} values
     * @param {number} total
     * @param {string} selectedAllocationType
     * @param {boolean} allocationTotalError
     * @param {*} action
     * @return {[]}
     */
    static computeAllocateForValues(values, total, selectedAllocationType, allocationTotalError, action = null) {
        if (values.length === 1) {
            values[0].value = total;
            values[0].isFixed = false;
            values[0].error = false;
            return values;
        }

        if (allocationTotalError && action !== 'add') {
            return values;
        }

        // Calculate the total to divide between the unfixed lines
        const subTotal = total - values.reduce((s, allocateFor) => s + (allocateFor.isFixed ? allocateFor.value : 0), 0);
        // Calculate the amount to share between the unfixed lines
        const divider = values.filter((allocateFor) => !allocateFor.isFixed).length;

        const decimals = allocationTypeDecimals(selectedAllocationType);

        const factor = Math.pow(10, decimals);

        const dividend = (Math.floor((subTotal / divider) * factor) / factor).toFixed(decimals);
        let accumulatedLoss = 0;
        const results = [];

        for (let i = 0; i < divider - 1; i++) {
            results.push(parseFloat(dividend));
            accumulatedLoss += (subTotal / divider) - parseFloat(dividend);
        }

        const lastValue = (subTotal / divider) + accumulatedLoss;
        results.push(parseFloat(lastValue.toFixed(decimals)));

        // Set value for each unfixed line
        let resultIndex = 0;
        for (let i = 0; i < values.length; i++) {
            if (!values[i].isFixed) {
                // Convert the result to a number before calling toFixed
                const numericValue = parseFloat(results[resultIndex]);
                if (!isNaN(numericValue)) {
                    values[i].value = Number(numericValue.toFixed(decimals));
                }
                resultIndex++;
            }
        }
        return values;
    }
}
